import styled, { css } from 'styled-components'
import Chevron from './Chevron'

const AccordionButton = styled.button(({
    active, complete, theme:{ colors }, warning
}) => css`
    background-color: ${active ? colors.grey700 : colors.white};
    border: none;
    border-left: 0.5rem solid ${warning ? colors.mustard100 : complete ? colors.aqua100 : colors.transparent};
    border-bottom: 1px solid ${active ? 'transparent' : colors.grey500};
    max-height: 4.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #444;
    cursor: pointer;
    padding: .8rem 1rem;
    outline: none;
    transition: background-color 0.6s ease;
    &:hover{
        background-color: ${colors.grey700};
    }
`)

const AccordionIcon = styled(Chevron)`
    margin-left: auto;
    transition: transform 0.6s ease;
    transform: ${props => props.active ? 'rotate(90deg)' : 'rotate(-90deg)'};
`

const AccordionContent = styled.div(({
    active, contentHeight, lastChild, theme:{ colors }
}) => css`
    background-color: white;
    overflow: auto;
    max-height: ${active ? `${contentHeight}px` : '0px'};
    border-bottom: ${active && !lastChild && `1px solid ${colors.grey500}`};
    transition: all .6s ease;
    &::-webkit-scrollbar {
        display: none;
    }
`)

export {
    AccordionButton,
    AccordionContent,
    AccordionIcon
}